(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("placeholder", [], factory);
	else if(typeof exports === 'object')
		exports["placeholder"] = factory();
	else
		root["placeholder"] = factory();
})(typeof self !== 'undefined' ? self : this, () => {
return 